/**
 * Esquemas Zod del dominio de Horario.
 *
 * El dominio es de **lectura**: no hay formularios. El único parámetro que viaja a
 * la API es el desplazamiento de semana (`?week=`), un entero que el backend valida
 * (`_week_offset` de `domains/scheduling.py`, 400 si no es entero). Aquí se modela
 * con Zod para que la navegación de semanas nunca produzca un valor inválido (p. ej.
 * un `NaN` por un cálculo erróneo), y el tipo se **infiere** del esquema
 * (`docs/frontend_conventions.md`, Validación), no se escribe a mano.
 */
import { z } from "zod";

/**
 * Desplazamiento de semana: entero (0 = semana actual; negativos = pasadas;
 * positivos = futuras). Coincide con lo que acepta `SchedulingService.build_schedule`
 * (vía `_week_offset`). No se acota el rango: el SSR tampoco lo hacía.
 */
export const weekOffsetSchema = z.number().int();

/** Desplazamiento de semana (inferido del esquema). */
export type WeekOffset = z.infer<typeof weekOffsetSchema>;
